<span [class]="'badge-text' + (classname ? ' ' + classname : '')">{{text}}</span>
